import { IModule } from 'redux-dynamic-modules';
import {
  getReducer as getConfigModuleReducer,
  setModulePath as setEdgeModulePath,
} from '@Utils/plarium/edgets-common/lib/configModule';
import * as mediaQueriesV3 from './mediaQueries-v3';
import state from './state';
import { UndoableLogoMakerState } from '@Components/LogoMaker/logoMakerState';

setEdgeModulePath('edge');

export type RootStateModule = {
  mediaQueriesV3: ReturnType<typeof mediaQueriesV3.reducer>;
  edge: ReturnType<ReturnType<typeof getConfigModuleReducer>>;
  state: ReturnType<typeof state>;
};

export function getRootModule(): IModule<RootStateModule> {
  return {
    id: 'root-dynamic-module',
    reducerMap: {
      mediaQueriesV3: mediaQueriesV3.reducer,
      edge: getConfigModuleReducer(),
      state,
    },
  };
}

type DynamicModules = UndoableLogoMakerState;

export type RootState = RootStateModule & DynamicModules;
